// @ts-nocheck


import Input from 'antd/lib/input';
import React, { useCallback } from 'react';

import { FilterItem } from '../../../../components';
import Field from '../../../../components/card/Field';
import { CommonFilter } from '../../../../components/hoc/common/handbook/CommonFilter';





export const CostAnalisysFilter = (
props) =>
{
  const Filter = useCallback(
    (filterProps) =>
    CommonFilter({ ...filterProps, ...props }),
    [props]
  );
  return (
    <Filter>
      {(values, changeValue) => {
        return (
          <>
            <FilterItem>
              <Field mBottomNone>
                <Input
                  size="small"
                  placeholder="Наименование анализа"
                  onChange={(e) => changeValue('name', e.target.value)}
                  value={values.name} />

              </Field>
            </FilterItem>
          </>);

      }}
    </Filter>);

};
export default CostAnalisysFilter;
